import { render } from "./CancelStart.vue?vue&type=template&id=6d318bbd"
import script from "./CancelStart.vue?vue&type=script&lang=js"
export * from "./CancelStart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__